import { format } from "date-fns";
import type { EventRow } from "../types/event";

export function formatInZoneISO(
  isoString: string,
  {
    timeZone = 'America/Sao_Paulo',
    locale = 'pt-BR',
  }: { timeZone?: string; locale?: string } = {}
) {
  const date = new Date(isoString); // respeita o offset da string ISO
  const parts = new Intl.DateTimeFormat(locale, {
    timeZone,
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(date);

  const pick = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find(p => p.type === type)?.value ?? '';

  return `${pick('day')} de ${pick('month')} de ${pick('year')} às ${pick('hour')}:${pick('minute')}`;
}

export function toGoogleCalendarUrl(ev: EventRow) {
  const start = formatUtcForGCal(ev.start_iso);
  const end = formatUtcForGCal(ev.end_iso || ev.start_iso);
  const details = encodeURIComponent((ev.description || "") + (ev.join_url ? `\n\nAcesso: ${ev.join_url}` : ""));
  const location = encodeURIComponent(ev.location_name || ev.address || "Online");
  const text = encodeURIComponent(ev.title);
  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${text}&dates=${start}/${end}&location=${location}&details=${details}`;
}

export function formatUtcForGCal(iso: string) {
  try {
    const d = new Date(iso);
    return new Date(d).toISOString().replace(/[-:.]/g, "").slice(0, 15) + "Z";
  } catch {
    return "";
  }
}

export function cryptoRandom() {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) return (crypto as any).randomUUID();
  return Math.random().toString(36).slice(2);
}

export function parseTags(s?: string) {
  return (s || "")
    .split(/[|,]/)
    .map((t) => t.trim())
    .filter(Boolean);
}

export function normalizeDate(iso: string | undefined, _tz?: string): Date | null {
  if (!iso) return null;
  try {
    // Se a string já contém informação de timezone, usar diretamente
    if (iso.includes('T') && (iso.includes('+') || iso.includes('-') || iso.includes('Z'))) {
      const d = new Date(iso);
      return isNaN(+d) ? null : d;
    }
    // Caso contrário, tratar como horário local
    const d = new Date(iso);
    return isNaN(+d) ? null : d;
  } catch {
    return null;
  }
}

export function pushGA(event: string, payload: Record<string, any>) {
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push({ event, ...payload });
}

export function shareLinks(ev: EventRow) {
  const page = typeof window !== 'undefined' ? window.location.origin + window.location.pathname : 'https://agenda.exemplo/';
  const url = new URL(page);
  url.searchParams.set('q', ev.title);
  url.searchParams.set('utm_source', 'share');
  url.searchParams.set('utm_medium', 'social');
  url.searchParams.set('utm_campaign', 'agenda');
  const u = encodeURIComponent(url.toString());
  const text = encodeURIComponent(`${ev.title} — ${ev.description || ''}`.slice(0, 200));
  return {
    whatsapp: `https://wa.me/?text=${text}%20${u}`,
    twitter: `https://twitter.com/intent/tweet?text=${text}&url=${u}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`
  };
}